export default {"src":"/_next/static/media/cy.4e1a5f99.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};